import { get } from '../../../../infra/rest';
import {
  GetRedirectParamsApiResponse,
  QuickReply,
} from '../../../../shared/typings/template';

export const getRedirectParams = async (
  chatId: string
): Promise<GetRedirectParamsApiResponse> => {
  const data = await get<GetRedirectParamsApiResponse>(
    `/v1/conversation/redirect-params/${chatId}`,
    {},
    true
  );
  return data;
};
